import { Anchor, Badge, Box, Card, Group, Text, ThemeIcon, UnstyledButton } from '@mantine/core'
import { IconCheck, IconTicket } from '@tabler/icons-react'
import type { Price } from 'api/dto/price'

interface TicketCardProps {
  price: Price
  isSelected: boolean
  onSelect: () => void
  t: (key: string) => string
}

export function TicketCard({ price, isSelected, onSelect, t }: TicketCardProps) {
  const isSoldOut = price.isSoldOut

  return (
    <UnstyledButton
      onClick={isSoldOut ? undefined : onSelect}
      sx={{
        width: '100%',
        cursor: isSoldOut ? 'not-allowed' : 'pointer',
        opacity: isSoldOut ? 0.6 : 1,
      }}
    >
      <Card
        padding="md"
        radius="md"
        sx={{
          border: isSelected ? '2px solid #850014' : '1px solid #e5e7eb',
          background: isSelected ? 'rgba(133, 0, 20, 0.03)' : '#fff',
          transition: 'all 0.2s ease',
          '&:hover': !isSoldOut
            ? {
                borderColor: '#850014',
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
              }
            : {},
        }}
      >
        <Group position="apart" noWrap>
          <Group spacing="sm" noWrap>
            <ThemeIcon size={40} radius="md" variant={isSelected ? 'filled' : 'light'} color={isSelected ? 'red' : 'gray'} sx={isSelected ? { background: '#850014' } : {}}>
              {isSelected ? <IconCheck size={20} /> : <IconTicket size={20} />}
            </ThemeIcon>
            <Box>
              <Group spacing={8} mb={2}>
                <Text weight={600} size="sm" color="#111827">
                  {price.name}
                </Text>
                {isSoldOut && (
                  <Badge size="xs" color="red" variant="filled">
                    {t('register.sold-out')}
                  </Badge>
                )}
              </Group>
              {price.description && (
                <Text size="xs" color="dimmed" lineClamp={2}>
                  {price.description}
                </Text>
              )}
            </Box>
          </Group>
          {price.waitingListUrl && isSoldOut && (
            <Anchor size="xs" color="red" href={price.waitingListUrl} target="_blank" onClick={(e: React.MouseEvent) => e.stopPropagation()}>
              {t('register.waiting-list')}
            </Anchor>
          )}
        </Group>
      </Card>
    </UnstyledButton>
  )
}
